import PdfDivider from "../../components/layout/PdfDivider";
import PdfSection from "../../components/layout/PdfSection";
import PdfSectionTitle from "../../components/typography/PdfSectionTitle";
import PdfTextBlock from "../../components/typography/PdfTextBlock";
import PdfPageBrandedSubmission from "../../pages/PdfPageBrandedSubmission";
import PdfBuilderSectionSignature from "../sections/PdfBuilderSectionSignature";

const PdfPageDisclosureAndSignature = ({ pageNumber, formData, type }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={pageNumber}
      pageTitle={"Disclosure & Signature"}
      submittedBy={`${formData?.firstName} ${formData?.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Authorization Agreement</PdfSectionTitle>

        <PdfTextBlock>
          Applicant attests that this application is for financing of a business
          purpose loan and any subject properties covered under this application
          are not owner occupied, used as a second home or vacation property,
          and any recent use of the property as a primary residence will require
          supporting evidence that all guarantors and their family members are
          no longer occupying the residence.
        </PdfTextBlock>

        <PdfTextBlock>
          The actual terms and conditions upon which the Lender might extend
          credit are subject to satisfactory completion of due diligence,
          internal approval, satisfactory review of documentation and such other
          or different items and conditions as may be determined by the Lender
          following the completion of its underwriting (the "Underwriting and
          Approval Process"). As a result, notwithstanding any agreement of the
          parties to the contrary, (i) Lender's approval of the loan documents
          shall not constitute a final approval of the loan and (ii) the loan
          documents shall not be considered final until the Underwriting and
          Approval Process is completed (as determined in Lender's sole
          discretion).
        </PdfTextBlock>

        <PdfTextBlock>
          The borrower hereby agrees that all aforementioned information is true
          and in no means is false and intended to influence the credit
          underwriting of the Lender in regard to origination of the loan
          associated with the subject property or properties. Additionally, the
          borrower understands that this loan application does not constitute a
          commitment from the Lender to originate the loan associated with the
          subject property or properties. Lastly, the borrower acknowledges that
          all fees collected in relation to loan due diligence are
          non-refundable, in any circumstance.
        </PdfTextBlock>
        {type === "loanApplication" ? (
          <PdfTextBlock>
            If necessary, I hereby authorize and instruct the Lender and its
            vendors/affiliates to obtain and review my personal credit report,
            background checks, and all other reports and documents and involving
            due diligence in connection with my real estate loan. I understand
            and agree that the Lender and its vendors/affiliates intends to use
            the credit report for the purpose of evaluating my financial
            readiness to personally guarantee the real estate loan that I have
            applied for. My signature below authorizes the release to credit
            report and screening agencies of financial or other information that
            I have supplied to the Lender and its vendors/affiliates in
            connection with such evaluation. Authorization is further granted to
            the credit report and screening agencies to use a copy of this form
            to obtain any information the agencies may deem necessary to
            complete my credit report and/or background screenings.
          </PdfTextBlock>
        ) : (
          <PdfTextBlock>
            I hereby authorize and instruct the Lender and its
            vendors/affiliates to obtain and review my personal credit report,
            background checks, and all other reports and documents and involving
            due diligence in connection with my real estate loan. I understand
            and agree that the Lender and its vendors/affiliates intends to use
            the credit report for the purpose of evaluating my financial
            readiness to personally guarantee the real estate loan that I have
            applied for. My signature below authorizes the release to credit
            report and screening agencies of financial or other information that
            I have supplied to the Lender and its vendors/affiliates in
            connection with such evaluation. Authorization is further granted to
            the credit report and screening agencies to use a copy of this form
            to obtain any information the agencies may deem necessary to
            complete my credit report and/or background screenings.
          </PdfTextBlock>
        )}
      </PdfSection>

      {formData?.signature && (
        <PdfBuilderSectionSignature
          submissionDate={formData?.submission_date}
          fullName={`${formData?.firstName} ${formData?.lastName}`}
          label="Borrower Signature:"
          signature={formData?.signature}
        />
      )}
      <PdfDivider />
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageDisclosureAndSignature;
